import React, {createContext, useContext} from "react";

const ImageMapProviderContext = createContext(null)

const ImageMapProvider = (props) => {
  return <ImageMapProviderContext.Provider value={props.imageMap}>
    {props.children}
  </ImageMapProviderContext.Provider>
}

const useImageMap = () => {
  return useContext(ImageMapProviderContext)
}

export {ImageMapProvider, useImageMap}